<section lvrPadding [padHorizontal]="32" [padVertical]="0" class="header">
	<h2>
		<ng-content></ng-content>
	</h2>
	<div class="actions-row">
		<ng-content select="button-content"></ng-content>
		@if (showEditButton()) {
			<div [matTooltip]="getEditTooltip() | transloco: getEditTooltipParams()">
				<lvr-button
					variant="primary"
					[label]="'base.button.edit' | transloco"
					[type]="'button'"
					[disabled]="disableEditButton()"
					(clicked)="editClicked.emit()"
					icon="edit"
				></lvr-button>
			</div>
		}
		@if (showDeleteButton()) {
			<div [matTooltip]="getDeleteTooltip() | transloco: getDeleteTooltipParams()">
				<lvr-button
					variant="primary"
					[label]="deleteTranslationKey() | transloco"
					[type]="'button'"
					[disabled]="disableDeleteButton()"
					(clicked)="deleteClicked.emit()"
					icon="delete"
				></lvr-button>
			</div>
		}
	</div>
</section>
